module.exports = __webpack_public_path__ + "img/white-ribbon.dc6a2feb.svg";